import React from 'react';
import { FormattedMessage } from 'react-intl';
/**
 * Live revalidation progress bar (AV-03). Pure presentational; the data comes
 * from the AV-01 `GET /revalidate/{jobId}` poll. CSP-safe (no external deps).
 */
export var ProgressBar = function (_a) {
    var processed = _a.processed, total = _a.total, errorsFound = _a.errorsFound, warningsFound = _a.warningsFound;
    var pct = total > 0 ? Math.min(100, Math.round((processed / total) * 100)) : 0;
    return (React.createElement("div", { "data-test-progress-bar": true },
        React.createElement("div", { role: "progressbar", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": pct, style: {
                height: '14px',
                width: '100%',
                background: '#e6ecf2',
                borderRadius: '7px',
                overflow: 'hidden',
            } },
            React.createElement("div", { style: {
                    height: '100%',
                    width: "".concat(pct, "%"),
                    background: '#2c5cc5',
                    transition: 'width 0.4s ease',
                } })),
        React.createElement("div", { style: { marginTop: '6px', fontSize: '12.5px', color: '#43525f' } },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.corpusQuality.progress", values: { processed: processed, total: total, pct: pct, errors: errorsFound, warnings: warningsFound } }))));
};
